// extracted by mini-css-extract-plugin
export default {"wrapper":"PromotionLabel_wrapper"};